"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = exports.SeparatorConfig = exports.SeparatorFieldType = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const validators_1 = require("../../../validators");
exports.SeparatorFieldType = "Separator";
exports.SeparatorConfig = t.exact(t.partial({
    label: validators_1.StringOrNull,
}));
exports.Separator = t.exact(t.intersection([
    t.type({
        type: t.literal(exports.SeparatorFieldType),
    }),
    t.partial({
        config: exports.SeparatorConfig,
    }),
]));
